import React from "react";
import Hero from "./Hero/index";
import CustomersExp from "./CustomersExp";
import OurProducts from "./OurProducts";
import CustomersReviews from "./CustomersReviews";
// import Layout from "../../components/Layout";
import Footer from "../../components/Footer";
import Header from "../../components/Header";

const HomePage = () => {
  return (
    <section className="w-full h-screen flex flex-col overflow-x-hidden">
      {/* <Layout> */}
      <Header />
      <Hero />
      <CustomersExp />
      <OurProducts />
      <CustomersReviews />
      <Footer />
      {/* </Layout> */}
    </section>
  );
};

export default HomePage;
